import { Box, Typography } from '@mui/material';
import { Panel } from './Panel';

/** A line of a vault note, readable: no list dash, no bold marks, links as plain names ("[[SRB-720]]" → "SRB-720") */
const clean = (line: string) =>
  line
    .replace(/^\s*[-*]\s*/, '')
    .replace(/\*\*/g, '')
    .replace(/\[\[([^\]|]*)(?:\|[^\]]*)?\]\]/g, '$1')
    .trim();

/** What the Serb Mind vault note says about a customer, agent or carrier: soft spots, do's and don'ts, history. Nothing shows when there is no note text. */
export function VaultNotes({ notes }: { notes: string }) {
  const lines = notes.split('\n').map(clean).filter(Boolean);
  if (!lines.length) return null;
  return (
    <Panel title="From Serb Mind">
      <Box component="ul" sx={{ m: 0, pl: 2.5, '& li': { mb: 0.75 } }}>
        {lines.map((l, i) => (
          <Typography key={i} component="li" variant="body2">
            {l}
          </Typography>
        ))}
      </Box>
    </Panel>
  );
}
